import { createApiSlice } from 'app/createApiSlice'
import { API_EVENT, API_EVENT_UTILS } from 'utils/apiList'

export const eventApprovalApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'eventApproval/hooks',
  endpoints(builder) {
    return {
      fetchEvent: builder.query({
        query(params) {
          if (params?.userId) {
            return {
              url: `${API_EVENT}/${params.userId}/users`,
              params,
            }
          } else {
            return {
              url: API_EVENT,
              params,
            }
          }
        },
      }),
      fetchEventForForm: builder.query({
        query() {
          return `${API_EVENT}?all=true`
        },
        transformResponse(response) {
          return response?.map((item) => ({
            value: item.id,
            label: item.title,
          }))
        },
      }),
      addEvent: builder.mutation({
        query(payload) {
          return {
            url: API_EVENT,
            method: 'POST',
            body: payload,
          }
        },
      }),
      editEvent: builder.mutation({
        query(payload) {
          return {
            url: `${API_EVENT}/${payload.id}`,
            method: 'PUT',
            body: payload,
          }
        },
      }),
      fetchUtilsEvent: builder.query({
        query() {
          return API_EVENT_UTILS
        },
        transformResponse: (response) => {
          const data = response

          if (!data) return {}

          const mapOptions = (arr, valueKey, labelKey) =>
            arr?.map((item) => ({
              value: item[valueKey],
              label: item[labelKey],
            })) || []

          return {
            eventType: mapOptions(data.eventType, 'id', 'name'),
            eventStatus: mapOptions(data.eventStatus, 'key', 'label'),
            eventParticipantStatus: mapOptions(
              data.eventParticipantStatus,
              'key',
              'label',
            ),
          }
        },
      }),
    }
  },
})

export const {
  useFetchEventQuery,
  useAddEventMutation,
  useEditEventMutation,
  useFetchUtilsEventQuery,
  useFetchEventForFormQuery,
} = eventApprovalApiSlice
